import { render, staticRenderFns } from "./ReportNotes.vue?vue&type=template&id=97481e4e&"
import script from "./ReportNotes.vue?vue&type=script&lang=js&"
export * from "./ReportNotes.vue?vue&type=script&lang=js&"
import style0 from "./ReportNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports